import * as React from "react";

import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {FieldItemBase, FieldItemBaseProps, FieldItemBaseState} from "InternalShared/PageBuilder/Fields/FieldItemBase";



export class FieldItem extends FieldItemBase<CustomFieldProps, CustomFieldState> {
    static defaultProps: Partial<CustomFieldProps> = {};

    constructor(props: CustomFieldProps) {
        super(props);
        this.state = {

        };
    }

    protected GetImage() {
        return 'fields.png'
    }

    protected GetText() {
        return 'Form Field'
    }

    protected GetType() {
        return ControlTypeEnum.Field;
    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface CustomFieldProps extends FieldItemBaseProps{

}

interface CustomFieldState extends FieldItemBaseState{

}

//#endregion "My Region"